import { render, staticRenderFns } from "./DialogBaseWhite.vue?vue&type=template&id=3831c6ea&scoped=true&"
import script from "./DialogBaseWhite.vue?vue&type=script&lang=js&"
export * from "./DialogBaseWhite.vue?vue&type=script&lang=js&"
import style0 from "./DialogBaseWhite.vue?vue&type=style&index=0&id=3831c6ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831c6ea",
  null
  
)

export default component.exports